export enum AccountProfile {
  ANONYMOUS = 'ANONYMOUS',
  UNQUALIFIED = 'NO_PROFILE',
  BUYER = 'BUYER',
  SELLER = 'SELLER',
  BOTH = 'BOTH',
}

export enum SellerProfile {
  SELLER_BOOST = 'SellerBoost',
  SELLER_BOOST_ASS = 'SellerBoostAss',
}

export type SwitchableAccountProfile = AccountProfile.BUYER | AccountProfile.SELLER;
